// Port de app/atualizacao-cadastral.tsx.
import { Carregando } from "@/app/Carregando";
import { Stack } from "@/navigation";
import { lazy } from "react";

const PRIMARY = "#294956";

const AtualizacaoCadastralScreen = lazy(() => import("@/screens/AtualizacaoCadastral"));

/**
 * Formulário da atualização cadastral pedida pelo RH. Rota de PILHA (não aba): é um fluxo
 * com começo e fim, aberto pelo aviso da Home — sem a barra inferior disputando a atenção
 * nem o toque. As opções de barra de status são as mesmas do suporte-chat.
 */
export default function AtualizacaoCadastralRoute() {
  return (
    <>
      <Stack.Screen
        options={{
          statusBarBackgroundColor: PRIMARY,
          navigationBarColor: PRIMARY,
          statusBarTranslucent: false,
        }}
      />
      <Carregando cor={PRIMARY}>
        <AtualizacaoCadastralScreen />
      </Carregando>
    </>
  );
}
